import React from 'react';
import { ArrowRight } from 'lucide-react';
export const Navbar = () => {
  return <nav className="sticky top-0 z-50 hidden md:flex justify-between items-center px-6 py-4 backdrop-blur-md bg-[#F6F4ED]/85" data-id="element-428">
      {/* Left: Logo */}
      <div className="flex items-center" data-id="element-429">
        <img src="https://cdn.magicpatterns.com/uploads/fGZPmBEEuygEB5KaVQhdrS/logohorizontal.png" alt="Aurora" className="h-[72px]" data-id="element-430" />
      </div>

      {/* Center: Links (Desktop) */}
      <div className="hidden md:flex items-center gap-8 bg-white px-8 py-3 rounded-full shadow-soft" data-id="element-431">
        <a href="#como-funciona" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-432">
          Como funciona
        </a>
        <a href="#beneficios" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-433">
          Benefícios
        </a>
        <a href="#preco" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-434">
          Preço
        </a>
        <a href="#duvidas" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-435">
          Dúvidas
        </a>
      </div>

      {/* Right: CTA */}
      <a href="#preco" className="hidden md:flex items-center gap-3 bg-ink text-white pl-6 pr-2 py-2 rounded-full hover:bg-ink/90 transition-colors no-underline" data-id="element-436">
        <span className="font-medium text-sm" data-id="element-437">Assinar agora</span>
        <div className="w-8 h-8 bg-rose rounded-full flex items-center justify-center" data-id="element-438">
          <ArrowRight size={16} className="text-white" data-id="element-439" />
        </div>
      </a>
    </nav>;
};